export const hyphenToUnderscore = (text: string): string => text.split('-').join('_');
